//region :: Imports ::
import {ReactElement, MouseEvent} from 'react';
import {classNames} from 'primereact/utils';
import {Outlet} from 'react-router-dom';
import MTopbarButton from './TopbarButton';
import MTopbar from './Topbar';
import MFooter from './Footer';
import {getUIThemeIcon, toggleUITheme} from '../../Utils';
import MComponent from '../Component';

//endregion

/** */
type Props = {
    appTitle: string;
    topbarButtons: ReactElement<MTopbarButton>[];
}

/** */
type State = {
    isActionsMenuVisible: boolean;
}

/** */
class MShell extends MComponent<Props, State> {

    /** */
    public constructor(props: Props) {
        super(props);

        this.bindMethods();
        this.state = this.createState();

    }

    /** */
    private bindMethods(): void {

        this.topbar_onActionsMenuClick = this.topbar_onActionsMenuClick.bind(this);
        this.toggleThemeButton_onClick = this.toggleThemeButton_onClick.bind(this);
        this.container_onClick = this.container_onClick.bind(this);

    }

    /** */
    private createState(): State {
        return {isActionsMenuVisible: false};
    }

    /** */
    private topbar_onActionsMenuClick(event: MouseEvent): void {

        event.preventDefault();
        this.safeSetState((draft: State) => {
            draft.isActionsMenuVisible = !draft.isActionsMenuVisible;
        });

    }

    /** */
    private toggleThemeButton_onClick(): void {
        toggleUITheme();
    }

    /** */
    private container_onClick(): void {

        if(this.state.isActionsMenuVisible) {

            this.safeSetState((draft: State) => {
                draft.isActionsMenuVisible = false;
            });

        }

    }

    /** */
    public render(): ReactElement {

        const containerClass = classNames('mshell', {
            'mshell-sidebar-hidden': true,
            'mshell-topbar-actionsmenu-visible': this.state.isActionsMenuVisible,
            'p-input-filled': false,
            'p-ripple-disabled': false
        });

        const actionButtons = this.props.topbarButtons.concat(
            [
                <MTopbarButton label="Change Theme"
                               icon={getUIThemeIcon()}
                               onClick={this.toggleThemeButton_onClick}/>
            ]
        );

        return (
            <div className={containerClass}
                 onClick={this.container_onClick}>

                {/* TopBar */}
                <MTopbar appTitle={this.props.appTitle}
                         actionButtons={actionButtons}
                         isActionsMenuVisible={this.state.isActionsMenuVisible}
                         onActionsMenuClick={this.topbar_onActionsMenuClick}/>

                {/* Container */}
                <div className="mshell-content-container-o">

                    <div className="mshell-content-container-i">
                        <Outlet/>
                    </div>

                    <MFooter companyName={'MJ Quinn Ltd'}
                             version={process.env.REACT_APP_VERSION!}/>

                </div>

            </div>
        );

    }

}

export default MShell;
